import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "./client";
import type { AlertTemplate } from "./types";

const invalidate = (qc: ReturnType<typeof useQueryClient>) =>
  qc.invalidateQueries({ queryKey: ["templates"] });

export function useTemplates() {
  return useQuery({
    queryKey: ["templates"],
    queryFn: async () => {
      const body = await apiFetch<{ templates: AlertTemplate[] }>("/api/v1/templates");
      return body.templates;
    },
  });
}

export function useCreateTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (t: AlertTemplate) =>
      apiFetch<AlertTemplate>("/api/v1/templates", { method: "POST", body: t }),
    onSuccess: () => invalidate(qc),
  });
}

export function useUpdateTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (t: AlertTemplate) =>
      apiFetch<AlertTemplate>(`/api/v1/templates/${t.id}`, { method: "PUT", body: t }),
    onSuccess: () => invalidate(qc),
  });
}

export function useDeleteTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      apiFetch<void>(`/api/v1/templates/${id}`, { method: "DELETE" }),
    onSuccess: () => invalidate(qc),
  });
}
